export default __webpack_public_path__ + "static/media/sliderscale.98b24e9c.png";